import React from 'react';
import { useLives } from '../context/LivesContext';
import styles from './LivesDisplay.module.css';

interface LivesDisplayProps {
  className?: string;
  style?: React.CSSProperties;
}

const LivesDisplay: React.FC<LivesDisplayProps> = ({ className, style }) => {
  const { lives } = useLives();

  return (
    <div className={`${styles.livesDisplay} ${className || ''}`} style={style}>
      <span className={styles.livesText}>
        Lives Remaining: {lives} <span role="img" aria-label="heart">❤️</span>
      </span>
    </div>
  );
};

export default LivesDisplay;